import { Event, Project, ProjectStatusEnum } from "@/graphql/generated/graphql";
import { map } from "lodash/fp";

export const formatSourceText = (parentSource: Event | Project) => {
  if (!parentSource) return;

  if (parentSource.__typename == 'Event') {
    return `Source Event: ${parentSource.uuid}`;
  } else if (parentSource.__typename == 'Project') {
    return `Source Project: ${parentSource.code}`;
  }
};

export const mapCodes = map('code');

export const getProjectPossibleStatuses = (currentStatus: ProjectStatusEnum | undefined) => {
  switch (currentStatus) {
    case ProjectStatusEnum.NotStarted:
      return [ProjectStatusEnum.InProgress, ProjectStatusEnum.Cancelled];
    case ProjectStatusEnum.InProgress:
      return [ProjectStatusEnum.Completed, ProjectStatusEnum.Cancelled, ProjectStatusEnum.OnHold];
    case ProjectStatusEnum.OnHold:
      return [ProjectStatusEnum.InProgress, ProjectStatusEnum.Cancelled];
    case ProjectStatusEnum.Completed:
    case ProjectStatusEnum.Cancelled:
      return []; // For now no further actions are allowed
    default:
      return [];
  }
};
